import URI from 'urijs';

export const CustomerHierarchyClassName = 'customer-hierarchy-tree';

// update cid/ aid query paramters of the url accordingly
export const DefaultUpdateEntityUrl = ({
  isCustomer, url, cid, aid, uid,
}) => {
  const targetUrl = new URI(url).setQuery('cid', cid).setQuery('uid', uid);

  return isCustomer ?
    targetUrl.removeQuery('aid').toString() :
    targetUrl.setQuery('aid', aid).toString();
};

// TODO: Move this to common constants for re-usability
export const InActiveAccountLifeCycleStatus = [32, 33];

export const AccountSelectorInactiveAccountsKey = 18192;

export const ShowInactiveEntitiesKey = 'showInactiveEntities';
